import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { IAddSingleBio } from 'src/types/GlobalInterfaces';
import SingleBioMarkerResult from '../GlobalComponents/HealthProfiles/SingleBioMarkerResult';

interface IProps {
    item: IAddSingleBio;
    uid: string;
    dob: string;
    gender: string;
    onSuccess: (id: string) => void;
    index?: number;
};

const PendingVitalComponent: React.FC<IProps> = ({
    item,
    dob = "",
    gender = "",
    uid = "",
    onSuccess = () => { },
    index = 0,
}) => {
    const [selectedId, setSelectedId] = useState<string>("");

    return (
        <div>
            <div className="biomarker-new-ui biomarker-new-ui-for-grid">
                <div>
                    <span className="font-size-16px text-white font-Poppins-Medium">{item?.name || ""}</span>
                </div>
                <div className="flex justify-center">
                    <span
                        // style={{ background: returnColor(item?.biomarkerColour) }}
                        className="new-biomarker-btn font-size-16px font-Poppins-Medium text-white"
                    >
                        {item?.measurement || ""}
                    </span>
                </div>
                <div></div>
                <div className="flex justify-center">
                    <FontAwesomeIcon
                        onClick={() => setSelectedId(selectedId ? "" : item?._id)}
                        className="cursor-pointer text-white"
                        icon={selectedId === item?._id ? faChevronUp : faChevronDown}
                        id={`vital-show-hide-btn-${item?.name}`}
                        size="sm"
                    />
                </div>
            </div>
            {selectedId === item?._id &&
                <div className={`new-health-vitals-dropdown`}>
                    <SingleBioMarkerResult
                        uid={uid}
                        _date={dob}
                        _gender={gender}
                        item={item}
                        onSuccess={() => onSuccess(item?._id)}
                        isCustomer={true}
                        index={index + 2000}
                        customId={`${item?.name}`}
                    />
                </div>
            }
        </div>
    );
};

export default PendingVitalComponent;